/**
 * Recharts renders its Tooltip via inline styles, not Tailwind classes, so it
 * doesn't pick up dark mode on its own. These props route it through the
 * same CSS variables as everything else (see index.css) so it matches
 * whichever theme is active.
 */
export const chartTooltipProps = {
  contentStyle: {
    backgroundColor: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 8,
    boxShadow: '0 8px 24px -12px rgba(0,0,0,.35)',
    color: 'var(--text-default)',
    fontSize: 13,
  },
  labelStyle: { color: 'var(--text-muted)', marginBottom: 4 },
  itemStyle: { color: 'var(--text-default)' },
  cursor: { fill: 'var(--surface-alt)' },
} as const;

/**
 * Shared Recharts axis tick styling so every BarChart's X/Y axis labels
 * render at the same (smaller) size — matches the 11px secondary text used
 * in the Cost efficiency by model chart instead of Recharts' larger default.
 */
export const chartAxisTickProps = {
  tick: { fill: 'var(--text-muted)', fontSize: 11 },
  tickLine: false,
} as const;

/** Shared category X-axis styling keeps longer dates and names readable. */
export const chartXAxisTickProps = {
  ...chartAxisTickProps,
  tick: { fill: 'var(--text-muted)', fontSize: 11, angle: -45, textAnchor: 'end' as const },
  height: 72,
} as const;

/** Shared Recharts legend styling, placed below the chart. */
export const chartLegendProps = {
  verticalAlign: 'bottom' as const,
  height: 32,
  wrapperStyle: { fontSize: 11, color: 'var(--text-muted)' },
};

/** Categorical series colors from the design system palette (§1.1–1.2), for charts with an arbitrary number of series. */
export const CHART_SERIES_COLORS = ['#0058AB', '#7B2FBE', '#049670', '#F4845F', '#00B4D8'] as const;
/** The "everything else" series after the top N. */
export const CHART_OTHER_COLOR = '#9299A4';
